/**
 * Basically checks if the label is on the form of
 * ("B, A") and if so converts it to "A B"
 */
export default label => {
    const s = label.split(',');
    if (s.length === 2) {
        return s[1].concat(' ', s[0]);
    }
    return label;
};
